<template>
  <Heading text="Galéria" class="mb-5" />
  <ClientOnly>
    <UtilitySwiper
      v-if="images.length"
      :slides-per-view="1.2"
      :space-between="20"
      :navigation="images.length > 4"
      :breakpoints="{
        640: {
          slidesPerView: 1.5,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 26.25,
        },
        1600: {
          slidesPerView: 4,
          spaceBetween: 26.25,
        },
      }"
    >
      <swiper-slide
        v-for="image in images"
        :key="image.documentId"
        class="!h-auto last-of-type:pr-6 last-of-type:lg:pr-0 cursor-pointer"
        @click="showModal(image)"
      >
        <UtilityImage
          :src="image?.url"
          :alt="image?.alternativeText || image?.name"
          class="w-full h-full aspect-[16/11]"
          image-class="rounded-lg object-cover"
        />
      </swiper-slide>
    </UtilitySwiper>

    <GalleryModal :images="lightboxImages" :index="indexRef" :visible="isLightboxVisible" @hide="isLightboxVisible = !isLightboxVisible" />
  </ClientOnly>
</template>
<script setup lang="ts">
import type { GalleryImage } from '~/utils/types'

const props = defineProps({
  images: {
    type: Array as PropType<GalleryImage[]>,
    required: true,
  },
})
const fixUrl = useFixUrl()

const isLightboxVisible = ref(false)
const indexRef = ref<number>(0)
const lightboxImages = computed<any[]>(() =>
  props.images.map((image: GalleryImage) => ({
    title: image?.name,
    src: fixUrl(image?.url),
    alt: image?.alternativeText || image?.name,
  })),
)

const showModal = (image: any) => {
  isLightboxVisible.value = true
  indexRef.value = props.images.indexOf(image)
}
</script>
